import Header from 'components/Header/Header';
import React from 'react';
import Footer from 'components/Footer/Footer';
import CategoryFilter from 'components/CategoryFilter/CategoryFilter';
import MobileAppDownloadBanner from 'components/MobileAppDownloadBanner/MobileAppDownloadBanner';
import {
  CenteredHeadline,
  MainContentWrapper,
  MainPageImage,
  MainPagePictureWrapper
} from 'styles/Page.styles';
import { MainPageComponentProps } from 'models/MainPageComponentProps';
import { FormattedMessage } from 'react-intl';

export const getMainPageComponents = ({
  onParameterChange,
  setMobileMenuOpen,
  mobileMenuOpen,
  categoryList,
  activeFilters
}: MainPageComponentProps) => {
  const showFooter = !activeFilters.embed;

  return (
    <>
      <Header
        activeFilters={activeFilters}
        onParameterChange={onParameterChange}
        category={undefined}
        hideNavigation={!!activeFilters.embed}
        mobileMenuHandler={{
          setMobileMenuOpen: setMobileMenuOpen,
          mobileMenuOpen: mobileMenuOpen
        }}
      />
      <MainContentWrapper>
        <CenteredHeadline>
          <FormattedMessage id="MAIN_PAGE.OUR_CATEGORIES" />
        </CenteredHeadline>
        <CategoryFilter
          categoryList={categoryList}
          activeFilters={activeFilters}
          styledAsButtons
        />
        <MainPagePictureWrapper>
          <picture>
            <source
              srcSet={`
          ${process.env.NEXT_PUBLIC_ASSET_PREFIX}${process.env.NEXT_PUBLIC_ASSET_PATH}/start-page-illustration-1x.webp 1x,
          ${process.env.NEXT_PUBLIC_ASSET_PREFIX}${process.env.NEXT_PUBLIC_ASSET_PATH}/start-page-illustration-2x.webp 2x`}
              type="image/webp"
            />
            <MainPageImage
              src={`${process.env.NEXT_PUBLIC_ASSET_PREFIX}${process.env.NEXT_PUBLIC_ASSET_PATH}/start-page-illustration.png`}
              alt="Start page illustration"
              width={860}
              height={725}
              loading="lazy"
            />
          </picture>
        </MainPagePictureWrapper>
      </MainContentWrapper>
      {showFooter && <Footer />}
      {showFooter && (
        <MobileAppDownloadBanner embedActive={!!activeFilters.embed} />
      )}
    </>
  );
};
